import React from 'react';
import { compose } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { TableSortLabel } from '@material-ui/core';

const styles = {
  firstTableCell: {
    borderRight: '1px solid #e0e0e0',
    padding: 10
  }
};

const enhance = compose();

const FavoriteShopTableHead = enhance(({ order, orderBy, onRequestSort }) => {
  return (
    <TableHead>
      <TableRow>
        <TableCell sortDirection={orderBy === 'shopName' ? order : false}>
          <TableSortLabel
            active={orderBy === 'shopName'}
            direction={order}
            onClick={() => {
              onRequestSort('shopName', 'favoriteShop');
            }}
          >
            店舗名
          </TableSortLabel>
        </TableCell>
      </TableRow>
    </TableHead>
  );
});

export default withStyles(styles)(FavoriteShopTableHead);
